function updateCountrySelect(element) {
  var currentURL = window.location.href;
  console.log("Current URL:", currentURL);

  if (currentURL.includes("https://global.revopoint3d.com/fr-fr")) {
    element.innerHTML =
      '<div class="flag flag-fr"></div><span lang="en">France</span>';
  } else if (currentURL.includes("https://global.revopoint3d.com/de-de")) {
    element.innerHTML =
      '<div class="flag flag-de"></div><span lang="en">DE</span>';
  } else if (currentURL.includes("https://global.revopoint3d.com/en-uk")) {
    element.innerHTML =
      '<div class="flag flag-uk"></div><span lang="en">UK</span>';
  } else if (currentURL.includes("https://global.revopoint3d.com/en-eur")) {
    element.innerHTML =
      '<div class="flag flag-eu"></div><span lang="en">Europe</span>';
  } else if (currentURL.includes("https://www.revopoint3d.com")) {
    element.innerHTML =
      '<div class="flag flag-usa"></div><span lang="en">USA</span>';
  } else if (currentURL.includes("https://www.revopoint3d.jp/")) {
    element.innerHTML =
      '<div class="flag flag-ja"></div><span lang="en">Japan</span>';
  } else {
    element.innerHTML =
      '<div class="flag flag-global"></div><span lang="en">Global</span>';
  }
}

document.addEventListener("DOMContentLoaded", function () {
  var countrySelectElements = [
    document.getElementById("countryselect"),
    document.getElementById("countryselect1"),
  ];

  countrySelectElements.forEach(function (element) {
    if (element) {
      updateCountrySelect(element);
    }
  });
});

function layer_country() {
  layer.open({
    type: 1,
    title: '<div class="countrylist-title"><h3>Select Your Country/Region</h3></div>',
    area: ["auto", "auto"],
    shadeClose: true, // 点击遮罩区域，关闭弹层
    content: ` 
        <div class="countrylist">
	<div class="country-item">
		<div class="country-title">
			<p>North America</p>
		</div>
		<div class="country-select">
			<a href="https://www.revopoint3d.com/?ref=selecter" ><li><span class="countrylist--desc">United States</span><span class="countrylist--lang">English/$USD</span></li></a>
			<a class="country-item" style="cursor: default;"><li><span class="countrylist--desc" style="font-weight: inherit;opacity: 0.5;">Canada</span><span class="countrylist--lang" style="opacity: 0.5;">Coming Soon</span></li></a>
		</div>
	</div>
	<div class="country-item">
		<div class="country-title">
			<p>Europe</p>
		</div>
		<div class="country-select">
			<a href="https://global.revopoint3d.com/en-uk?ref=selecter"><li><span class="countrylist--desc">United Kingdom</span><span class="countrylist--lang">English/£GBP</span></li></a>
			<a href="https://global.revopoint3d.com/fr-fr?ref=selecter"><li><span class="countrylist--desc">France</span><span class="countrylist--lang">Français/€EUR</span></li></a>
			<a href="https://global.revopoint3d.com/de-de?ref=selecter"><li><span class="countrylist--desc">Deutschland</span><span class="countrylist--lang">Deutsch/€EUR</span></li></a>
			<a href="https://global.revopoint3d.com/en-eur?ref=selecter"><li><span class="countrylist--desc">Europe</span><span class="countrylist--lang">English/€EUR</span></li></a>
		</div>
	</div>
	<div class="country-item">
		<div class="country-title">
			<p>Asia Pacific</p>
		</div>
		<div class="country-select">
			<a href="https://www.revopoint3d.com.cn"><li><span class="countrylist--desc">中国大陆</span><span class="countrylist--lang">中文 / ¥ CNY</span></li></a>
			<a href="https://tw.revopoint3d.com"><li><span class="countrylist--desc">中國台灣</span><span class="countrylist--lang">繁體中文 / NT $</span></li></a>
			<a href="https://www.revopoint3d.jp/?ref=selecter"><li><span class="countrylist--desc">日本</span><span class="countrylist--lang">日本語/¥JPY</span></li></a>
		</div>
	</div>
	<div class="country-item">
		<div class="country-title">
			<p>Other Countries and Regions</p>
		</div>
		<div class="country-select">
			<a href="https://global.revopoint3d.com/?ref=selecter"><li><span class="countrylist--desc">Global</span><span class="countrylist--lang">English / $ USD</span></li></a>
		</div>
	</div>
</div>`,
  });
}
